import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const MapCmsBlock_Box_1 = styled.div`
  position: absolute;

  &[data-offset-anchors] {
    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      top: -56px;
    }
  }
`;
